export function extractFeatureIcons(metafieldsMap): string[] {
    return Array.from({ length: 7 }, (_, index) => {
        const key = `custom.feature_icon_${index + 1}`;
        return metafieldsMap[key] || '';
    });
}
